
import roles from './rolespermission.json';
import { useAuth } from './context/AuthContext';

 const  IsEnabled =(page='')=>{
  const { user } = useAuth();
 
  const rolePermission = roles.find(r => r.role.toUpperCase() === user.role.toUpperCase());
  const role =rolePermission.role.toUpperCase();
  if (role === 'ADMIN') {
    return true;
  } else if (role === "VIEWER") {
    return false;
  } else if (role === "EDITOR") {
    return rolePermission.pages.includes(page);
  } else {
    return false;
  }
}

export default IsEnabled;